module.exports = __webpack_public_path__ + "static/Background-mla-2.67db00a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mla-2.jpg
// module id = 471
// module chunks = 172546399187757